// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-size: 16px !important;
}

@media screen and (max-width: 1150px),
screen and (max-height: 500px) {
  :root {
    font-size: 14px !important;
  }
}

@media screen and (max-width: 900px),
screen and (max-height: 500px) {
  :root {
    font-size: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/responsive.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[":root {\n  font-size: 16px !important;\n}\n\n@media screen and (max-width: 1150px),\nscreen and (max-height: 500px) {\n  :root {\n    font-size: 14px !important;\n  }\n}\n\n@media screen and (max-width: 900px),\nscreen and (max-height: 500px) {\n  :root {\n    font-size: 12px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
